import z from 'zod';
import {moduleTopicSchema} from './moduleTopicSchema';
import {standardSubjectSchema} from './StandardSubject';
import {subjectLevelSchema} from './SubjectLevel';

/** Writable fields for exam module (create/update). requiredRole optional on input; default when writing. */
export const examModuleWriteSchema = z.object({
  name: z.string(),
  level: subjectLevelSchema,
  examBoard: z.string().optional(),
  subject: standardSubjectSchema,
  topics: z.array(moduleTopicSchema),
  questionsPerTopic: z.number().optional(),
  requiredRole: z.string().optional().default(''),
  attribution: z.string().optional(),
  author: z.string().optional(),
  source: z.string().optional(),
  license: z.string().optional(),
  disableStudy: z.boolean().optional(),
  disableQuestion: z.boolean().optional(),
});

export type ExamModuleWrite = z.infer<typeof examModuleWriteSchema>;
